module.exports = __webpack_public_path__ + "static/img/banner-问煤.cc2ee60b.webp";